webpackJsonp([94529631104657],{

/***/ 1381:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Expanded Financing Options Now Available from Skills Fund","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/expanded-financing-options-now-available-from-skills-fund","createdAt":"2016-08-16T17:31:54.310Z","blogAuthor":{"fields":{"name":"Lauren Bauml","slug":"blog/author/lauren-bauml"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/5w5PG68uTSMCoY46KYs2M8/f768cc98e14ace529a8a7988a33297e0/blog-post-blog-expanded-financing-options-now-available-from-skills-fund.png"}}}}}]},"authorJson":{"name":"Lauren Bauml","slug":"blog/author/lauren-bauml","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/lauren-bauml"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-lauren-bauml-d50aa2007f810a78c1b0.js